






































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { VueEditor } from "vue2-editor";
import { required, numeric } from "vuelidate/lib/validators";
import VueSelect from "vue-select";
import DatePicker from "vuejs-datepicker";
import moment from "moment";
import numeral from "numeral";
import {
  GapRecord,
  GapLabTest,
  Form,
  FormQuestion,
  User,
} from "@/store/modules/types";
import { GapField, GapStatus, GapSubStatus } from "@/store/modules/enums";
import PatientSearch from "@/components/PatientSearch.vue";
import GapLog from "@/components/gap/GapLog.vue";
import GapLabTestEditor from "@/components/gap/GapLabTestEditor.vue";
import ModalHeader from "@/components/ModalHeader.vue";
import PatientViewer from "@/components/patient/PatientViewer.vue";
import { BCard, BTabs, BTab, BCardText } from "bootstrap-vue";
import InputPopover from "@/components/InputPopover.vue";
import MultipleInputPopover from "@/components/MultipleInputPopover.vue";
import SelectPopover from "@/components/SelectPopover.vue";
import { uploadFile } from "@/services/storage";
import FormWizard from "@/components/FormWizard.vue";
import FormViewer from "@/components/FormViewer.vue";
import { getDate } from '@/services/timezone';

@Component({
  components: {
    ModalHeader,
    VueSelect,
    VueEditor,
    DatePicker,
    PatientSearch,
    GapLog,
    GapLabTestEditor,
    PatientViewer,
    BCard,
    BTabs,
    BTab,
    BCardText,
    InputPopover,
    MultipleInputPopover,
    SelectPopover,
    FormWizard,
    FormViewer,
  },
  computed: {
    ...mapState("auth", ["user", "entityId"]),
    ...mapState("gaps", [
      "campaigns",
      "insurers",
      "measures",
      "measureTypes",
      "priority",
      "status",
      "subStatus",
      "reasons",
      "users",
    ]),
  },
  validations: {
    gapRecord: {
      campaignId: {
        required,
        numeric,
      },
       insurerId: {
        /* required,
        numeric, */
      },
      insurerMemberId: {
        //required,
      }, 
      patientId: {
        required,
        numeric,
      },
      measureId: {
        required,
        numeric,
      },
      providerId: {
        required,
        numeric,
      },
      referenceDate: {
        required,
      },
      refGapId: {
        numeric,
      },
    },
  },
})
export default class GapEditor extends Vue {
  @Prop(Number) readonly gapId!: number;
  user!: User;
  getDate = getDate;
  entityId!: string;
  gapRecord: GapRecord = {
    id: null,
    campaignId: "",
    campaignName: "",
    insurerId: "",
    insurerName: "",
    insurerMemberId: "",
    patientId: "",
    patientPhoneType: "",
    patientPhone: "",
    patientFirstName: "",
    patientLastName: "",
    patientLastName2: "",
    patientGender: "",
    patientGenderName: "",
    patientBirthdate: "",
    patientAddress: "",
    description: "",
    measureId: "",
    measureTypeId: null,
    measureTypeName: "",
    measureName: "",
    measureDescription: "",
    providerId: "",
    providerName: "",
    referenceDate: "",
    admissionDate: "",
    admissionDiagnosis: "",
    admissionProviderName: "",
    testDate: "",
    testResultValue: "",
    dischargeDiagnosis: "",
    facilityName: "",
    pharmacyName: "",
    medicationName: "",
    lang: "EN",
    priorityId: "NRML",
    priorityName: "",
    statusId: "PEN",
    statusName: "",
    subStatusId: "PEN",
    subStatusName: "",
    closeReasonId: "1",
    closeReasonName: "",
    closeSubReasonId: "1",
    closeSubReasonName: "",
    closeDate: "",
    refGapId: "",
    ownerUserId: "",
    fileId: "",
    recordDate: "",
    creatorUserName: "",
    lastUpdate: "",
    modifierUserName: "",
    comment: "",
    transportation: null,
  };
  quill = {
    toolbar: [
      ["bold", "italic", "underline"],
      [{ list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
    ],
  };
  measures!: Array<any>;
  measureTypes!: Array<any>;
  measureTypeId = "";
  closeSubReasons: Array<any> = [];
  files = {
    selected: null as any,
    description: "",
    list: Array<any>(),
  };
  labs = {
    list: Array<any>(),
    selected: this.getCleanLab(),
  };
  providers = Array<any>();
  links = Array<any>();
  gapForms = {
    list: Array<Form>(),
    selected: {
      form: {} as Form,
      questions: Array<FormQuestion>(),
    },
  };
  forms = Array<Form>();
  async getGap() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const data = await this.$store.dispatch("gaps/getRecord", this.gapId);
      data.comment = "";
      this.gapRecord = data;
      this.measureTypeId = data.measureTypeId;
      this.getSubReasons();
      this.getForms();
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async getSubReasons() {
    try {
      const { closeReasonId, closeSubReasonId } = this.gapRecord;
      this.closeSubReasons = await this.$store.dispatch(
        "gaps/getSubReasons",
        closeReasonId
      );
      const found = this.closeSubReasons.find((r) => r.id === closeSubReasonId);
      if (!found) {
        this.gapRecord.closeSubReasonId = this.closeSubReasons[0].id;
      }
    } catch (error) {
      console.log(error);
    }
  }
  async getFiles() {
    try {
      this.files.list = await this.$store.dispatch("gaps/getFiles", this.gapId);
    } catch (error) {
      console.log(error);
    }
  }
  async getProviders() {
    try {
      this.providers = await this.$store.dispatch("gaps/getProviders");
    } catch (error) {
      console.log(error);
    }
  }
  async getForms() {
    try {
      const { measureTypeId } = this.gapRecord;
      this.forms = await this.$store.dispatch("gaps/getForms", measureTypeId);
    } catch (error) {
      console.log(error);
    }
  }
  async getGapForms() {
    try {
      this.gapForms.list = await this.$store.dispatch(
        "gaps/getGapForms",
        this.gapId
      );
    } catch (error) {
      console.log(error);
    }
  }
  async addForm(item) {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const { gapId } = this;
      const { id } = item;
      await this.$store.dispatch("gaps/saveForm", { gapId, id });
      this.getGapForms();
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
    // const exists = list.find((i) => i.id === item.id);
    // if (exists) return;
    // else {
    //   this.$store.commit("main/SET_LOADING", true);
    //   try {
    //     const { gapId } = this;
    //     const { id } = item;
    //     await this.$store.dispatch("gaps/saveForm", { gapId, id });
    //     list.push(item);
    //   } catch (error) {
    //     console.log(error);
    //   } finally {
    //     this.$store.commit("main/SET_LOADING", false);
    //   }
    // }
  }
  async delForm(item) {
    this.$modal.show("dialog", {
      title: `Remove ${item.url}`,
      text: "Are you sure?",
      buttons: [
        {
          title: "Yes",
          handler: async () => {
            this.$store.commit("main/SET_LOADING", true);
            try {
              const { id } = item;
              const { list } = this.gapForms;
              const index = list.findIndex((t) => t.id === item.id);
              await this.$store.dispatch("gaps/archiveForm", id);
              list.splice(index, 1);
              this.$modal.hide("dialog");
            } catch (error) {
              console.log(error);
            } finally {
              this.$store.commit("main/SET_LOADING", false);
            }
          },
        },
        {
          title: "No",
          default: true,
        },
      ],
    });
  }
  async openForm(item: Form, wizard: boolean) {
    this.gapForms.selected.form = item;
    this.$store.commit("main/SET_LOADING", true);
    try {
      const { id } = item;
      const questions: FormQuestion[] = await this.$store.dispatch(
        "gaps/getFormQuestions",
        id
      );
      if (this.gapRecord.id) {
        questions.forEach((q) => {
          if (!q.answer.value && q.options && q.options.gapField) {
            const { gapField } = q.options;
            const { answer } = q;
            switch (gapField) {
              // CASE
              case GapField.GAP_ID:
                answer.value = this.gapRecord.id;
                break;
              case GapField.GAP_CAMPAIGN:
                answer.value = this.gapRecord.campaignName;
                break;
              case GapField.GAP_PROVIDER:
                answer.value = this.gapRecord.providerName;
                break;
              case GapField.GAP_INSURER:
                answer.value = this.gapRecord.insurerName;
                break;
              case GapField.GAP_DESCRIPTION:
                answer.value = this.gapRecord.description;
                break;
              case GapField.GAP_MEASURE_TYPE:
                answer.value = this.gapRecord.measureTypeName;
                break;
              case GapField.GAP_MEASURE:
                answer.value = this.gapRecord.measureName;
                break;
              case GapField.GAP_REF_DATE:
                answer.value = this.gapRecord.referenceDate;
                break;
              case GapField.GAP_ADMISSION_DATE:
                answer.value = this.gapRecord.admissionDate;
                break;
              case GapField.GAP_ADMISSION_DIAGNOSIS:
                answer.value = this.gapRecord.admissionDiagnosis;
                break;
              case GapField.GAP_ADMISSION_PROVIDER:
                answer.value = this.gapRecord.admissionProviderName;
                break;
              case GapField.GAP_TEST_DATE:
                answer.value = this.gapRecord.testDate;
                break;
              case GapField.GAP_TEST_RESULT:
                answer.value = this.gapRecord.testResultValue;
                break;
              case GapField.GAP_DISCHARGE_DIAGNOSIS:
                answer.value = this.gapRecord.dischargeDiagnosis;
                break;
              case GapField.GAP_FACILITY:
                answer.value = this.gapRecord.facilityName;
                break;
              case GapField.GAP_PHARMACY:
                answer.value = this.gapRecord.pharmacyName;
                break;
              case GapField.GAP_MEDICATION:
                answer.value = this.gapRecord.medicationName;
                break;
              case GapField.GAP_PRIORITY:
                answer.value = this.gapRecord.priorityName;
                break;
              case GapField.GAP_STATUS:
                answer.value = this.gapRecord.statusName;
                break;
              case GapField.GAP_SUB_STATUS:
                answer.value = this.gapRecord.subStatusName;
                break;
              case GapField.GAP_CLOSE_REASON:
                answer.value = this.gapRecord.closeReasonName;
                break;
              case GapField.GAP_CLOSE_SUB_REASON:
                answer.value = this.gapRecord.closeSubReasonName;
                break;
              case GapField.GAP_CLOSE_DATE:
                answer.value = this.gapRecord.closeDate;
                break;
              case GapField.GAP_REF_ID:
                answer.value = this.gapRecord.refGapId;
                break;
              // PATIENT
              case GapField.PATIENT_ID:
                answer.value = this.gapRecord.patientId;
                break;
              case GapField.PATIENT_FIRST_NAME:
                answer.value = this.gapRecord.patientFirstName;
                break;
              case GapField.PATIENT_LAST_NAME:
                answer.value = this.gapRecord.patientLastName;
                break;
              case GapField.PATIENT_LAST_NAME_2:
                answer.value = this.gapRecord.patientLastName2;
                break;
              case GapField.PATIENT_FULL_NAME:
                answer.value =
                  this.gapRecord.patientLastName +
                  " " +
                  this.gapRecord.patientLastName2 +
                  ", " +
                  this.gapRecord.patientFirstName;
                break;
              case GapField.PATIENT_GENDER:
                answer.value = this.gapRecord.patientGenderName;
                break;
              case GapField.PATIENT_BIRTHDATE:
                answer.value = this.gapRecord.patientBirthdate;
                break;
              case GapField.PATIENT_FULL_ADDRESS:
                answer.value = this.gapRecord.patientAddress;
                break;
              case GapField.PATIENT_INSURER:
                answer.value = this.gapRecord.insurerName;
                break;
              case GapField.PATIENT_MEMBER_ID:
                answer.value = this.gapRecord.insurerMemberId;
                break;
              //
              case GapField.USER_LONG_NAME:
                answer.value = this.$store.state.auth.user.userLongName;
                break;
              //
            }
          }
          //jumpToKey
          if (q.answer.value && q.options) {
            var opt = q.options.list?.filter(
              (opt) => opt.value === q.answer.value
            )[0];
            if (opt) q.answer.jumpToKey = opt.jumpToKey;
          }
          //
        });
      }
      this.gapForms.selected.questions = questions;
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
    if (wizard) {
      this.$modal.show("form-wizard");
    } else {
      this.$modal.show("form-viewer");
    }
  }
  async saveFormAnswers(answers) {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const { id } = this.gapForms.selected.form;
      await this.$store.dispatch("gaps/saveFormAnswers", {
        id,
        answers,
      });
      this.getGap();
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async saveFile() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const { gapId } = this;
      const file = this.fileInput().files![0];
      const fileId = await uploadFile(this.entityId, file);
      const data = await this.$store.dispatch("gaps/saveFile", {
        gapId,
        fileId,
      });
      this.getFiles();
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async saveFileDesc() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const fileId = this.files.selected.id;
      const { gapId } = this;
      const { description } = this.files;
      await this.$store.dispatch("gaps/saveFileDesc", {
        gapId,
        fileId,
        description,
      });
      this.files.selected.description = description;
      this.$modal.hide("gap-file-desc");
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  archiveFile(file) {
    this.$modal.show("dialog", {
      title: "Remove " + file.name,
      text: "Are you sure?",
      buttons: [
        {
          title: "Yes",
          handler: async () => {
            this.$store.commit("main/SET_LOADING", true);
            try {
              const { gapId } = this;
              const fileId = file.id;
              await this.$store.dispatch("gaps/archiveFile", { gapId, fileId });
              this.$modal.hide("dialog");
              this.getFiles();
            } catch (error) {
              console.log(error);
            } finally {
              this.$store.commit("main/SET_LOADING", false);
            }
          },
        },
        {
          title: "No",
          default: true,
        },
      ],
    });
  }
  async getLabs() {
    try {
      this.labs.selected = this.getCleanLab();
      this.labs.list = await this.$store.dispatch(
        "gaps/getLabTests",
        this.gapId
      );
    } catch (error) {
      console.log(error);
    }
  }
  async getLinks() {
    try {
      this.links = await this.$store.dispatch("gaps/getLinks", this.gapId);
    } catch (error) {
      console.log(error);
    }
  }
  editLab(lab) {
    this.labs.selected = lab || this.getCleanLab();
    this.$modal.show("gap-lab-test");
  }
  archiveLab(lab) {
    this.$modal.show("dialog", {
      title: "Remove " + lab.name,
      text: "Are you sure?",
      buttons: [
        {
          title: "Yes",
          handler: async () => {
            this.$store.commit("main/SET_LOADING", true);
            try {
              const { gapId } = this;
              const testId = lab.id;
              await this.$store.dispatch("gaps/archiveLabTest", {
                gapId,
                testId,
              });
              this.$modal.hide("dialog");
              this.getLabs();
            } catch (error) {
              console.log(error);
            } finally {
              this.$store.commit("main/SET_LOADING", false);
            }
          },
        },
        {
          title: "No",
          default: true,
        },
      ],
    });
  }
  getCleanLab(): GapLabTest {
    return {
      id: null,
      typeId: "",
      name: "",
      date: "",
      testComment: "",
      resultValue: "",
      resultComment: "",
      fileId: null,
    };
  }
  async save() {
    if (this.$v.gapRecord && this.$v.gapRecord.$invalid) {
      this.$v.gapRecord.$touch();
      return;
    }
    this.$store.commit("main/SET_LOADING", true);
    try {
      await this.$store.dispatch("gaps/save", this.gapRecord);
      this.$modal.hide("gap-editor");
      this.$emit("gap-saved");
    } catch (error) {
      const message: string = error.response.data;
      const ALREADY_EXISTS_ERROR = "PATIENT_MEASURE_REFDATE_ALREADY_EXISTS";
      if (message.includes(ALREADY_EXISTS_ERROR)) {
        this.$modal.show("dialog", {
          title: `WaitingMed`,
          text: "A record with this <b>patient</b>, <b>measure</b> and <b>reference date</b> already exists.",
        });
      } else {
        console.log(error);
      }
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async updateLink(
    url: string,
    description: string,
    id: number,
    index: number
  ) {
    if (!url) return;
    const link = {
      id: id,
      url: url.toLowerCase(),
      description: description,
    };

    this.links[index].url = url.toLowerCase();
    this.links[index].description = description;
    this.saveLink(link);
  }

  async saveNewLink(url: string, description: string) {
    if (!url) return;
    const link = {
      id: null,
      url: url.toLowerCase(),
      description: description,
    };
    this.saveLink(link);
  }
  async saveLink(item) {
    try {
      const { gapId } = this;
      const { id, url, description } = item;
      await this.$store.dispatch("gaps/saveLink", {
        gapId,
        id,
        url,
        description,
      });
      this.$bvToast.toast(`Link saved!`, {
        title: "WaitingMed",
        toaster: "b-toaster-top-right",
        autoHideDelay: 2000,
        solid: true,
      });
      if (!item.id) this.getLinks();
    } catch (error) {
      console.log(error);
    }
  }
  async archiveLink(item) {
    this.$modal.show("dialog", {
      title: `Remove ${item.url}`,
      text: "Are you sure?",
      buttons: [
        {
          title: "Yes",
          handler: async () => {
            try {
              const { gapId } = this;
              const { id } = item;
              await this.$store.dispatch("gaps/archiveLink", {
                gapId,
                id,
              });
              this.$bvToast.toast(`Link archived!`, {
                title: "WaitingMed",
                toaster: "b-toaster-top-right",
                autoHideDelay: 2000,
                solid: true,
              });
              this.getLinks();
              this.$modal.hide("dialog");
            } catch (error) {
              console.log(error);
            }
          },
        },
        {
          title: "No",
          default: true,
        },
      ],
    });
  }
  checkStatus() {
    /*   if (this.gapRecord.statusId === GapStatus.CLOSED) {
      this.gapRecord.subStatusId = GapSubStatus.COMPLETED;
    } */
  }

  setDefault() {
    var reason = this.$store.state.gaps.reasons.filter(
      (r) => r.isDefault === true
    );
    var priority = this.$store.state.gaps.priority.filter(
      (p) => p.isDefault === true
    );

    //gapRecord.priorityId
    if (reason.length) {
      this.gapRecord.closeReasonId = reason[0].id;
      this.getSubReasons();
    }

    if (priority.length) {
      this.gapRecord.priorityId = priority[0].id;
    }
  }
  setPatient(patient, phoneType, phone) {
    if (!phoneType && !phone) {
      phoneType = patient.mobilePhone
        ? "M"
        : patient.homePhone
        ? "H"
        : patient.otherPhone
        ? "O"
        : patient.otherPhone2
        ? "O"
        : "";
      phone =
        patient.mobilePhone ||
        patient.homePhone ||
        patient.otherPhone ||
        patient.otherPhone2 ||
        "";
    }
    if (patient.insurerId) {
      this.gapRecord.insurerId = patient.insurerId;
    }
    if (patient.insurerMemberId) {
      this.gapRecord.insurerMemberId = patient.insurerMemberId;
    }
    this.gapRecord.patientId = patient.id;
    this.gapRecord.patientFirstName = patient.firstName;
    this.gapRecord.patientLastName = patient.lastName;
    this.gapRecord.patientBirthdate = moment(patient.birthdate).format(
      "YYYY-MM-DD"
    );
    this.gapRecord.patientPhoneType = phoneType;
    this.gapRecord.patientPhone = phone;
    this.gapRecord.lang = patient.lang;
    this.$modal.hide("patient-search");
  }
  getPatientLocation() {
    const address = this.gapRecord.patientAddress.trim();
    if (address) {
      window.open("https://maps.google.com/?q=" + address, "_blank");
    }
  }
  get filteredMeasures(): Array<any> {
    if (this.measureTypeId) {
      const measures = this.measures.filter(
        (m) => m.type === this.measureTypeId
      );
      if (measures.length === 1) {
        this.gapRecord.measureId = measures[0].id;
      } else if (!this.gapRecord.id) {
        this.gapRecord.measureId = "";
      }
      return measures;
    }
    return this.measures;
  }
  fileInput(): HTMLInputElement {
    return document.querySelector("input[type='file']") as HTMLInputElement;
  }
  fileExt(file) {
    return file.name
      .slice(((file.name.lastIndexOf(".") - 1) >>> 0) + 2)
      .toLowerCase();
  }
  fileIsImage(file) {
    const ext = this.fileExt(file);
    const arr = [
      "jpg",
      "jpeg",
      "tiff",
      "gif",
      "bmp",
      "png",
      "webp",
      "svg",
      "ai",
      "eps",
    ];
    return arr.indexOf(ext) >= 0;
  }
  fileIcon(file) {
    if (this.fileIsImage(file)) {
      return "fa-file-image";
    } else {
      const ext = this.fileExt(file);
      switch (ext) {
        case "doc":
        case "docx":
          return "fa-file-word";
        case "xls":
        case "xlsx":
          return "fa-file-excel";
        case "ppt":
        case "pptx":
          return "fa-file-powerpoint";
        case "pdf":
          return "fa-file-pdf";
        case "txt":
          return "fa-file-alt";
        case "zip":
          return "fa-file-archive";
        case "avi":
        case "wmv":
        case "mov":
        case "qt":
        case "flv":
        case "swf":
        case "mpg":
        case "mpe":
        case "mpv":
        case "mp2":
        case "mp4":
        case "m4p":
        case "m4v":
        case "ogg":
        case "mpeg":
        case "webm":
          return "fa-file-video";
        default:
          return "fa-file";
      }
    }
  }
  fileSize(file) {
    return numeral(file.size).format("0 b");
  }
  fileDesc(file) {
    this.files.selected = file;
    this.files.description = file.description;
    this.$modal.show("gap-file-desc");
  }
  async fileView(file) {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const { gapId } = this;
      const { storageId } = file;
      const { uri } = await this.$store.dispatch("gaps/getFileUrl", {
        gapId,
        storageId,
      });
      window.open(uri, "_blank");
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async fileDownload(file) {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const { gapId } = this;
      const { storageId } = file;
      const { uri } = await this.$store.dispatch("gaps/getFileDownloadUrl", {
        gapId,
        storageId,
      });
      window.location.href = uri;
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  mounted() {
    if (this.gapId) {
      this.getGap();
      this.getLabs();
      this.getFiles();
      this.getLinks();
      this.getGapForms();
    } else {
      this.gapRecord.ownerUserId = this.user.id.toString();
      this.setDefault();
    }
    this.getProviders();
  }
}
